<template>
	<div v-if="data.campaigns && data.campaigns.length">
			<div class="row">
				<div class="col-xl-12">
					<div class="block">
						<div class="block-header block-header-default d-flex flex-fill justify-content-between">
							<h3 class="block-title">Onboard Venues</h3>
							<div>
								Onboard Links:
								<div class="btn-group">
									<button type="button" class="btn btn-warning dropdown-toggle btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										<i class="fa fa-external-link-alt"></i>
									</button>
									<ul class="dropdown-menu">
										<li v-for="camp in data.campaigns" v-if="camp.onboardLink"><a class="dropdown-item" :href="camp.onboardLink" style="cursor: pointer;">{{camp.name}}</a></li>
									</ul>
								</div>
							</div>
						</div>
						<div class="block-content border" v-if="data.campaigns">
							<div class="row">
								<div class="col col-sm-10 col-md-6 col-lg-3">
									<select id="campaignId" class="form-control" v-model="filters.campaignId" @change="getVenues()">
										<option :value="null">- All Campaigns -</option>
										<option v-for="campaign in data.campaigns" :value="campaign.id">{{campaign.name}}</option>
									</select>
								</div>
								<div class="col col-sm-10 col-md-6 col-lg-3" v-if="data.campaigns.length">
									<multiselect
											id="statuses"
											v-model="selected_statuses"
											:options="data.statuses"
											:multiple="true"
											:close-on-select="false"
											track-by="id"
											label="name"
											:hide-selected="true"
											placeholder="Campaign Status(es)"
											@input="getVenues(true)"
									></multiselect>
								</div>
								<div class="col col-sm-10 col-md-6 col-lg-3" v-if="data.campaigns.length">
									<multiselect
											id="venueStatuses"
											v-model="selected_venue_statuses"
											:options="data.venueStatuses"
											:multiple="true"
											:close-on-select="false"
											track-by="id"
											label="name"
											:hide-selected="true"
											placeholder="Venue Status(es)"
											@input="getVenues(true)"
									></multiselect>
								</div>
								<div class="col col-sm-2 col-md-1">
									<button v-on:click="resetData" class="btn btn-light btn-sm text-muted nav-main-link" ><i class="si si-reload fa-1x mr-1"></i><span>Reset</span></button>
								</div>
							</div>
							<div class="mt-2" v-if="venues.data && venues.data.length">
								<table class="table table-condensed table-striped" >
									<thead>
									<th>Venue</th>
									<th>Campaign Status</th>
									<th>Venue Status</th>
									</thead>
									<tbody>
									<tr v-for="venue in venues.data">
										<td>
											<a :href="venue.onboardLink" v-if="venue.onboardLink" target="_blank" class="ml-2 js-tooltip-enabled" data-toggle="tooltip" data-placement="top" title="Onboard Link">{{ venue.name }}</a>
										</td>
										<td>
											<span>{{ venue.campaignStatus || 'Not Set' }}</span>
										</td>
										<td>{{ venue.statusName }}</td>
									</tr>
									</tbody>

								</table>
								<bw-pagination
										:pagination="venues"
										style="margin-left: 20px;"
										@paginate="onPaginate"
										:offset="4"
										:per-page="filters.display"
										@update-per-page="updatePerPage($event)"
								>
								</bw-pagination>
							</div>
							<div class="p-2" v-else-if="!filters.campaignId">Select a Campaign</div>
							<div class="p-2" v-else>No Venues</div>
						</div>
<!--						<div class="block-content">-->
<!--							<table class="table table-borderless table-striped table-vcenter font-size-sm">-->
<!--								<tbody>-->
<!--								<tr v-for="venue in data.onboardVenues">-->
<!--									<td class="font-w600 text-left">-->
<!--										<a :href="venue.onboardLink">{{ venue.name }}</a>-->
<!--									</td>-->
<!--									<td class="d-none d-sm-table-cell">-->
<!--										{{ venue.statusName }}-->
<!--									</td>-->
<!--									<td>-->
<!--										{{ Bandwango.dateToLocal(venue.created_at) }}-->
<!--									</td>-->
<!--								</tr>-->
<!--								</tbody>-->
<!--							</table>-->
<!--						</div>-->
					</div>
				</div>
			</div>
	</div>
</template>

<script>
	export default {
		props: {
			data: {
				type: Object,
				default: {}
			}
		},
		components: {

		},
		methods: {
			getVenues() {
				const self = this;

				if( !this.filters.campaignId )
					this.filters.campaignId = this.data.campaigns[0].id;

				this.venuesLoading = false;
				this.venues.data = [];

				if (this.venues.current_page > 1) {
					this.filters.page = this.venues.current_page;
				} else {
					this.filters.page = 1;
				}

				if (!this.filters.display) this.filters.display = 20;
				var url = '/campaigns/'+this.filters.campaignId+'/getCampaignAssignmentsPopulated';
				$.ajax({
					url,
					type: "GET",
					data: this.filters,
					dataType: "json",

					success: function(response) {
						self.venues = response;
						self.venuesLoading = false;
					},
					error: function(response) {
						Bandwango.helpers("swal", {
							title: "Error!",
							text: response.responseText,
							icon: "error",
						});
						self.venuesLoading = false;
					},
				});
			},
			resetData() {
				Object.keys(this.filters).forEach((key) => {
					if (key === 'searchType') {
						this.filters[key] = $("#filter-search-type a:first").data('option-value');
					} else if (key === 'dateProperty') {
						this.filters[key] = $("#filter-date-property option:first").val();
					} else {
						if (Array.isArray(this.filters[key])) {
							this.filters[key] = [];
						} else {
							this.filters[key] = null;
						}
					}
				});
				this.venues = [];
				this.cookieFilters();
			},

			cookieFilters: function() {

				// Need cookie for filters. Name should be TYPE-filters.
				var date = new Date();
				date.setHours(23,59,59,999);
				var expires = "expires=" + date.toGMTString();
				document.cookie = "onboard-venue-filters="+JSON.stringify(this.filters)+"; "+expires+";path=/";
			},
			onPaginate() {
				this.getVenues();
			},
			updatePerPage(event) {
				this.filters.display = event.display;
				this.filters.page = 1;
				this.venues.current_page = 1
				this.getVenues();
			},
		},
		data() {
			return {
				filters:{
					campaignId: null,
					statuses:[],
					statuses2:[],
					display:20
				},
				venues: {
					data: [],
					total: 0,
					from: 1,
					to: 0,
					current_page: 1,
				},
				venuesLoading:false
			};
		},
		beforeMount() {

		},
		mounted() {
			if( this.data.filters )
				this.filters = this.data.filters;
			if( !this.filters.statuses )
				this.filters.statuses = [];
			if( !this.filters.statuses2 )
				this.filters.statuses2 = [];

			if( this.data.campaigns.length )
				this.getVenues();
		},
		computed: {
			selected_statuses: {
				get() {
					return this.data['statuses'].filter((status) => {
						return this.filters.statuses.map(Number).indexOf(status.id) > -1;
					});
				},
				set(newVal) {
					this.filters.statuses = newVal.map((v) => v.id);
				}
			},
			selected_venue_statuses: {
				get() {
					return this.data['venueStatuses'].filter((status) => {
						return this.filters.statuses2.map(Number).indexOf(status.id) > -1;
					});
				},
				set(newVal) {
					this.filters.statuses2 = newVal.map((v) => v.id);
				}
			}
		},
	};
</script>